import { render, staticRenderFns } from "./WishList.vue?vue&type=template&id=c2436d7c&scoped=true"
import script from "./WishList.vue?vue&type=script&lang=js"
export * from "./WishList.vue?vue&type=script&lang=js"
import style0 from "./WishList.vue?vue&type=style&index=0&id=c2436d7c&prod&lang=scss&scoped=true"
import style1 from "./WishList.vue?vue&type=style&index=1&id=c2436d7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2436d7c",
  null
  
)

export default component.exports